/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FinancialChannelPermissionRequest } from './FinancialChannelPermissionRequest';
import {
    FinancialChannelPermissionRequestFromJSON,
    FinancialChannelPermissionRequestFromJSONTyped,
    FinancialChannelPermissionRequestToJSON,
    FinancialChannelPermissionRequestToJSONTyped,
} from './FinancialChannelPermissionRequest';
import type { AddOrUpdateBankAccountRequest } from './AddOrUpdateBankAccountRequest';
import {
    AddOrUpdateBankAccountRequestFromJSON,
    AddOrUpdateBankAccountRequestFromJSONTyped,
    AddOrUpdateBankAccountRequestToJSON,
    AddOrUpdateBankAccountRequestToJSONTyped,
} from './AddOrUpdateBankAccountRequest';

/**
 * Request for add or updat financial channel
 * @export
 * @interface AddOrUpdateFinancialChannelRequest
 */
export interface AddOrUpdateFinancialChannelRequest {
    /**
     * The title of financial channel
     * @type {string}
     * @memberof AddOrUpdateFinancialChannelRequest
     */
    title?: string;
    /**
     * The type of financial channel
     * @type {string}
     * @memberof AddOrUpdateFinancialChannelRequest
     */
    type?: string;
    /**
     * Indicate if the appointment type is active
     * @type {boolean}
     * @memberof AddOrUpdateFinancialChannelRequest
     */
    active?: boolean;
    /**
     * 
     * @type {AddOrUpdateBankAccountRequest}
     * @memberof AddOrUpdateFinancialChannelRequest
     */
    bankAccounts?: AddOrUpdateBankAccountRequest;
    /**
     * 
     * @type {Array<FinancialChannelPermissionRequest>}
     * @memberof AddOrUpdateFinancialChannelRequest
     */
    permissions?: Array<FinancialChannelPermissionRequest>;
}

/**
 * Check if a given object implements the AddOrUpdateFinancialChannelRequest interface.
 */
export function instanceOfAddOrUpdateFinancialChannelRequest(value: object): value is AddOrUpdateFinancialChannelRequest {
    return true;
}

export function AddOrUpdateFinancialChannelRequestFromJSON(json: any): AddOrUpdateFinancialChannelRequest {
    return AddOrUpdateFinancialChannelRequestFromJSONTyped(json, false);
}

export function AddOrUpdateFinancialChannelRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddOrUpdateFinancialChannelRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'title': json['title'] == null ? undefined : json['title'],
        'type': json['type'] == null ? undefined : json['type'],
        'active': json['active'] == null ? undefined : json['active'],
        'bankAccounts': json['bankAccounts'] == null ? undefined : AddOrUpdateBankAccountRequestFromJSON(json['bankAccounts']),
        'permissions': json['permissions'] == null ? undefined : ((json['permissions'] as Array<any>).map(FinancialChannelPermissionRequestFromJSON)),
    };
}

export function AddOrUpdateFinancialChannelRequestToJSON(json: any): AddOrUpdateFinancialChannelRequest {
    return AddOrUpdateFinancialChannelRequestToJSONTyped(json, false);
}

export function AddOrUpdateFinancialChannelRequestToJSONTyped(value?: AddOrUpdateFinancialChannelRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'title': value['title'],
        'type': value['type'],
        'active': value['active'],
        'bankAccounts': AddOrUpdateBankAccountRequestToJSON(value['bankAccounts']),
        'permissions': value['permissions'] == null ? undefined : ((value['permissions'] as Array<any>).map(FinancialChannelPermissionRequestToJSON)),
    };
}

